<script>
  import Button from "../button/button.svelte";
  import { cart } from "$lib/cart-store.svelte.js";
  import ShoppingCart from "@lucide/svelte/icons/shopping-cart";

  let buttonType = $derived(cart.buttonType.toLowerCase());
</script>

{#if buttonType === "text"}
  <Button
    >{cart.buttonText}
    {#if cart.itemsIndicator}
      ({cart.itemCount})
    {/if}</Button
  >
{:else}
  <Button size="icon" variant="default" class="relative">
    <ShoppingCart />
    {#if cart.itemsIndicator}
      <span class="absolute top-0.5 right-0.5 text-xs">
        {cart.itemCount}
      </span>
    {/if}
  </Button>
{/if}
